<template>
    <section class="profile-wrapper auth_container">
        <div class="container">
            <div class="form_container">
                <v-row>
                    <v-col cols="12" lg="6">
                        <div class="auth_image_container">
                            <div class="auth-group-1">
                                <img src="@/assets/images/group-1.png" />
                            </div>
                            <div class="auth-main-image">
                                <img src="@/assets/images/laptop.png" />
                            </div>
                            <div class="auth-group-2">
                                <img src="@/assets/images/group-2.png" />
                            </div>
                        </div>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <div class="form_header_part">
                            <v-row align="center" justify="space-between">
                                <v-col cols="12" md="6">
                                    <div class="form_header_title">
                                        Profile
                                    </div>

                                </v-col>
                                <v-col cols="12" class="col-md">
                                    <v-btn
                                        type="button" class="big_blue_button" 
                                        :loading="loading"
                                        :disabled="loading"
                                        @click="$router.push('/profile/edit'), loader = 'loading', $bus.emit('loading-toggle')"
                                    >
                                        Edit Profile
                                        <template v-slot:loader>
                                            <span>Loading...</span>
                                        </template>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                         <v-card flat class="py-4 pt-7 px-4 grey lighten-4" elevation="0">
                            <span class="title black--text font-weight-bold d-block mb-4"> 
                                <strong class="black--text">{{profile.full_name}}</strong>
                            </span>
                            <span class="body-2 black--text font-weight-light d-block mb-2">
                                <v-icon class="black--text mr-3" medium>mdi-at</v-icon> 
                                <strong class="black--text font-weight-bold mr-2">Email Address: </strong> {{profile.email}}
                            </span>
                            <!-- <span class="body-2 black--text font-weight-light d-block mb-2">
                                <v-icon class="black--text mr-3" medium>mdi-account-outline</v-icon> 
                                <strong class="black--text font-weight-bold mr-2">Username: </strong> {{profile.username}}
                            </span> -->
                            <span class="body-2 black--text font-weight-light d-block mb-2">
                                <v-icon class="black--text mr-3" medium>mdi-cellphone-iphone</v-icon> 
                                <strong class="black--text font-weight-bold mr-2">Phone: </strong> {{profile.phone_number}}
                            </span>

                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'Profile',
    data:()=>({
        profile: [],
        loader: null,
        loading: false,
    }),
    async mounted () {
        await this.$api.get('/authuser/get-profile/').then(res => {
            this.profile = res;
        })  
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      },
    },
}
</script>

<style>

</style>